import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';

import { RentVerification } from 'src/api/rentVerificationApi';
import { RootState } from 'src/store';
import { Status as StatusTypes } from 'src/ts/enums';
import { IPaginationRequest } from 'src/ts/interfaces';
import { NAME } from './constants';
import { rentVerificationGetAllThunk } from './services';

export type StateData = {
  data: RentVerification[] | null;
  count: number;
  filters: IPaginationRequest;
  status: StatusTypes;
  error?: string | null;
};

export const initialState: StateData = {
  data: null,
  count: 0,
  filters: {
    q: '',
    page: 0,
    rowsPerPage: 50
  },
  status: StatusTypes.IDLE,
  error: null
};

const rentVerificationSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    filtering: (state: StateData, action) => {
      state.filters.filter = action.payload.filter;
      state.filters.page = action?.payload?.page;
      state.filters.rowsPerPage = action?.payload?.rowsPerPage;
    },
    pagination: (state: StateData, action) => {
      state.filters.page = action?.payload?.page;
      state.filters.rowsPerPage = action?.payload?.rowsPerPage;
    },
    search: (state: StateData, action) => {
      state.filters.q = action.payload.q;
      state.filters.page = action?.payload?.page;
      state.filters.rowsPerPage = action?.payload?.rowsPerPage;
    },
    sorting: (state: StateData, action) => {
      state.filters.sort = action.payload.sort;
      state.filters.page = action?.payload?.page;
      state.filters.rowsPerPage = action?.payload?.rowsPerPage;
    },
    clearSearch: (state: StateData) => {
      state.filters.q = '';
      state.filters.page = 0;
    },
    clearAllFilters: (state: StateData) => {
      state.filters = {
        ...initialState.filters,
        rowsPerPage: state.filters.rowsPerPage
      };
    }
  },
  extraReducers: (builder) => {
    rentVerificationGetAllReducer(builder);
  }
});

const rentVerificationGetAllReducer = (builder: ActionReducerMapBuilder<StateData>) => {
  builder.addCase(rentVerificationGetAllThunk.pending, (state) => {
    state.status = StatusTypes.LOADING;
    state.error = null;
  });
  builder.addCase(rentVerificationGetAllThunk.fulfilled, (state, action) => {
    state.status = StatusTypes.SUCCESS;
    state.data = action.payload.data;
    state.count = action.payload.total;
  });
  builder.addCase(rentVerificationGetAllThunk.rejected, (state, action) => {
    state.status = StatusTypes.ERROR;
    state.error = action.error?.message;
  });
};

export const selectors = (state: RootState) => ({
  data: state[NAME].data,
  count: state[NAME].count,
  filters: state[NAME].filters,
  status: state[NAME].status,
  error: state[NAME].error
});

export const { reducer, actions } = rentVerificationSlice;
